var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bulk-actions-overlay",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.closeWizard($event)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "bulk-actions-container" },
        [
          !_vm.actionProcessing
            ? _c(
                "div",
                { staticClass: "close-button", on: { click: _vm.closeWizard } },
                [_c("md-icon", [_vm._v("close")])],
                1
              )
            : _vm._e(),
          _c(
            "simple-wizard",
            {
              attrs: {
                title: "Updating " + _vm.selectedRows.length + " records",
                "sub-title": _vm.getSubtitle,
                "is-multiple-transaction": false,
                "disable-navigation-headers": true,
              },
              on: { finish: _vm.finishWizard, stepChange: _vm.onStepChange },
              scopedSlots: _vm._u([
                {
                  key: "footer",
                  fn: function (ref) {
                    var nextTab = ref.nextTab
                    var prevTab = ref.prevTab
                    var activeIndex = ref.activeIndex
                    var tabCount = ref.tabCount
                    return [
                      activeIndex < tabCount - 1
                        ? _c("div", { staticClass: "wizard-footer-buttons" }, [
                            _c(
                              "div",
                              [
                                activeIndex > 0
                                  ? _c(
                                      "md-button",
                                      {
                                        staticClass: "btn-previous",
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.customPrevTab(
                                              activeIndex,
                                              prevTab
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                            Previous\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              [
                                _c(
                                  "md-button",
                                  {
                                    staticClass: "btn-next",
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.customNextTab(
                                          activeIndex,
                                          nextTab
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          activeIndex === 2 ? "Confirm" : "Next"
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ])
                        : _c("div"),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "wizard-tab",
                {
                  attrs: {
                    label: "Step 1 - Choose Bulk Action",
                    id: "chooseBulkActionTab",
                  },
                },
                [
                  _c(
                    "transition",
                    { attrs: { name: "slide-fade", mode: "out-in" } },
                    [
                      _c("div", { staticClass: "wizard-tab-content" }, [
                        _c(
                          "div",
                          { staticClass: "wizard-tab-section" },
                          [
                            _c("choose-bulk-action", {
                              attrs: {
                                "selected-rows": _vm.selectedRows,
                                "selected-action-index":
                                  _vm.selectedActionIndex,
                              },
                              on: { "action-selected": _vm.selectAction },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "wizard-tab",
                {
                  attrs: {
                    label: "Step 2 - ADD DETAILS",
                    "before-change": _vm.validateStep2AddDetails,
                    id: "addDetailsTab",
                  },
                },
                [
                  _c(
                    "transition",
                    { attrs: { name: "slide-fade", mode: "out-in" } },
                    [
                      _c("div", { staticClass: "wizard-tab-content" }, [
                        _c(
                          "div",
                          { staticClass: "wizard-tab-section" },
                          [
                            _vm.selectedActionIndex === 0
                              ? _c("assign-driver", {
                                  attrs: {
                                    "selected-driver-id": _vm.selectedDriverId,
                                  },
                                  on: { "driver-selected": _vm.selectDriver },
                                })
                              : _vm._e(),
                            _vm.selectedActionIndex === 1
                              ? _c("change-status", {
                                  attrs: {
                                    "selected-status": _vm.selectedStatus,
                                  },
                                  on: { "status-selected": _vm.selectStatus },
                                })
                              : _vm._e(),
                            _vm.selectedActionIndex === 2
                              ? _c("add-stop-note", {
                                  attrs: {
                                    "selected-note": _vm.selectedNote,
                                    "selected-note-type": _vm.selectedNoteType,
                                  },
                                  on: {
                                    "note-selected": _vm.selectNote,
                                    "note-type-selected": _vm.selectNoteType,
                                  },
                                })
                              : _vm._e(),
                            _vm.selectedActionIndex === 5
                              ? _c("set-date", {
                                  attrs: { "selected-date": _vm.selectedDate },
                                  on: { "date-selected": _vm.selectDate },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "wizard-tab",
                {
                  attrs: {
                    label: "Step 3 - Confirmation",
                    id: "confirmationTab",
                  },
                },
                [
                  _c(
                    "transition",
                    { attrs: { name: "slide-fade", mode: "out-in" } },
                    [
                      _c("div", { staticClass: "wizard-tab-content" }, [
                        _c(
                          "div",
                          { staticClass: "wizard-tab-section" },
                          [
                            _c("confirm-bulk-action", {
                              attrs: {
                                "selected-rows": _vm.selectedRows,
                                "selected-driver-id": _vm.selectedDriverId,
                                "selected-status": _vm.selectedStatus,
                                "selected-note": _vm.selectedNote,
                                "selected-note-type": _vm.selectedNoteType,
                                "selected-date": _vm.selectedDate,
                                "selected-action-index":
                                  _vm.selectedActionIndex,
                                "team-members": _vm.teamMembers,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "wizard-tab",
                {
                  attrs: {
                    label: "Step 4 - Processing",
                    "before-change": function () {
                      return false
                    },
                    id: "processingTab",
                  },
                },
                [
                  _c(
                    "transition",
                    { attrs: { name: "slide-fade", mode: "out-in" } },
                    [
                      _c("div", { staticClass: "wizard-tab-content" }, [
                        _c(
                          "div",
                          { staticClass: "wizard-tab-section" },
                          [
                            _c("bulk-action-progress", {
                              attrs: {
                                "action-completed": _vm.actionCompleted,
                              },
                              on: { acknowledge: _vm.acknowledgeComplete },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }